import * as React from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { JSSClassesProps } from 'react-jss';
import { LeftArrowIcon } from '../Icons/LeftArrowIcon';

import { ComponentJSSClasses, animatedClasses } from './styles';


export interface OpenerBlockProps {
    title: string;
    isOpen: boolean;
    fullWidht?: boolean;
    onClose: () => void;
    children?: JSX.Element;
}

interface StyledOpenerBlockProps extends JSSClassesProps<ComponentJSSClasses>, OpenerBlockProps { }


export class OpenerBlock extends React.Component<StyledOpenerBlockProps, []> {

    render() {
        const { classes } = this.props;

        return (
            <div className={classes.container}>
                {this.props.isOpen && (
                    <div className={classes.overlay} />
                )}
                <ReactCSSTransitionGroup
                    transitionName={animatedClasses}
                    transitionLeaveTimeout={300}
                    transitionAppearTimeout={300}
                    transitionEnterTimeout={300}
                    component={'div'}
                >
                    {this.props.isOpen && (
                        <div className={`${classes.content} ${this.props.fullWidht ? classes.fullWidth : ''}`}>
                            <div className={classes.header}>
                                <button
                                    className={classes.closeButton}
                                    onClick={this.props.onClose}
                                >
                                    <LeftArrowIcon />
                                </button>
                                <div className={classes.title}>{this.props.title}</div>
                            </div>
                            <div className={classes.children}>
                                {this.props.children}
                            </div>
                        </div>
                    )}
                </ReactCSSTransitionGroup>
            </div>
        );
    }

}
